import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from '@angular/core';
import { AppState } from '../../app.service';
import { scrollTo } from '@api/utils';
var CheckoutIntroComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function CheckoutIntroComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: '' };
        this.scrollTo = scrollTo;
    }
    CheckoutIntroComponent.prototype.ngOnInit = function () {
    };
    CheckoutIntroComponent.prototype.submitState = function (value) {
    };
    return CheckoutIntroComponent;
}());
export { CheckoutIntroComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-intro/checkout-intro.component.ts
// module id = null
// module chunks = 